class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

  
    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
  
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick
    );
  
    this.onSummaryMouseEnter = this.onSummaryMouseEnter.bind(this);
    this.summaryToggle.addEventListener(
      'mouseenter',
      this.onSummaryMouseEnter
    );
  
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );
  
    this.summaryToggle.setAttribute('role', 'button');
  
    this.onBodyClick = this.onBodyClick.bind(this);
    this.isOpen = this.isOpen.bind(this);
  }
  

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }
  
  megaMenuDetails() {
    detailsElems.forEach((detailsElem) => {
      detailsElem.addEventListener('mouseenter', () => {
        // Remove "open" attribute from any other open details elements
        detailsElem.forEach((otherElem) => {
          if (otherElem !== detailsElem && otherElem.hasAttribute('open')) {
            otherElem.removeAttribute('open');
            otherElem.style.pointerEvents = 'none';
          }
        });
        // Add "open" attribute to the hovered details element
        detailsElem.setAttribute('open', '');
        otherElem.style.pointerEvents = 'initial';
      });
    });
  }

  onSummaryMouseEnter(event) {
    if (!this.isOpen()) {
      this.open(event);
    }
  }
  
  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    const detailsElem = event?.target?.closest('details');
    if (detailsElem) {
      detailsElem.setAttribute('open', true);
    } else {
      this.detailsContainer.setAttribute('open', true);
    }
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
  
    if (!event) return;
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
    event?.stopPropagation();
  }
  
  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
